import {
  AddPersonFormSchemaType,
  AddPersonModal,
  useCreatePerson,
} from '@common';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

export const AddPersonButton: React.FC = () => {
  const { t } = useTranslation('persons');
  const [opened, { open, close }] = useDisclosure(false);
  const { createPerson } = useCreatePerson();

  const handleSubmit = async (data: AddPersonFormSchemaType): Promise<void> => {
    await createPerson(data);
  };

  return (
    <>
      <Button
        size="xs"
        color="blue"
        onClick={open}
        aria-label={t('ADD_PERSON')}
      >
        <FontAwesomeIcon icon={faPlus} />
      </Button>
      <AddPersonModal opened={opened} onClose={close} onSubmit={handleSubmit} />
    </>
  );
};
